import RateConversationActionTypes from '../action-types/rate-conversation';
export const clearConversationStatus = () => ({
    type: RateConversationActionTypes.CLEAR_CONVERSATION_STATUS,
});
export const setConversationStatus = (conversationStatus) => ({
    type: RateConversationActionTypes.SET_CONVERSATION_STATUS,
    payload: conversationStatus,
});
export const setRateConversationOpen = (isOpen) => ({
    type: RateConversationActionTypes.SET_RATE_CONVERSATION_OPEN,
    payload: isOpen,
});
export const setRate = (rate) => ({
    type: RateConversationActionTypes.SET_RATE,
    payload: rate,
});
export const setRateHover = (rate) => ({
    type: RateConversationActionTypes.SET_RATE_HOVER,
    payload: rate,
});
export const setHostName = (name) => ({
    type: RateConversationActionTypes.SET_HOST_NAME,
    payload: name,
});
